// Attach a delegated click listener to handle any element with data-open-reviews
document.addEventListener('click', (event) => {
  const target = event.target as HTMLElement | null;
  if (!target) return;

  const trigger = target.closest('[data-open-reviews]') as HTMLElement | null;
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  document.dispatchEvent(new Event('open-reviews-tab'));
});
